$(function ($) {
  $('.product-single__description h4').each(function(){ 
    var $set = $(this).nextUntil("h4");
    $set.wrapAll('<div class="panel" />');
  });

  $(".product-single__description h4").addClass('accordion');
  $('.panel').hide();

  $(".rte.product-single__description > .accordion:nth-child(1)").addClass('open').next('.panel').show();  
  $('.product-single__description .accordion').on('click', function(){
    // $('.panel').hide();
    //$('.accordion').removeClass('active');
    $(this).toggleClass('open');
    var isVisible = $(this).next().is(':visible');
    console.log(isVisible);
    if(isVisible == true){
      $(this).next().hide(300);
    }else{
      $(this).next().show(300);
    }
  });
});



$(function(){
    $('#create_customer').submit(function(e) {     
      if ( $('input[name="customer[password]"]').val() != $('input[name="customer[password_confirmation]"]').val()) {
        e.preventDefault();
        alert('Passwords do not match.');
      }
    });
  });



/*start slick slider*/
jQuery(document).ready(function(){
jQuery('.hvac_coll_list .slick-carousel').slick({
  infinite: true,
  autoplay: false,
  slidesToShow: 3,
  slidesToScroll: 1, 
  arrows: true, 
  dots: false,
  responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 575,
        settings: {
            slidesToShow: 1,
        }
      }	
    ]
});



//Get currnet month

var sk_today = new Date();
var month = sk_today.toLocaleString('default', { month: 'long' });

$(".current_month").html(month + " ");
  

jQuery('.slick_menus').slicknav({
  allowParentLinks: false,
  prependTo: '#sk_slick_menu',
  label: ''
});


jQuery('.slick_menus_tab').slicknav({
  allowParentLinks: false,
  prependTo: '#sk_slick_menu_tab',
  label: ''
});

jQuery(".menu_sl_close_tab").on("click", function() {
  jQuery('.slick_menus_tab').slicknav('close');  
});
  
  
jQuery(".menu_sl_close").on("click", function() {
  jQuery('.slick_menus').slicknav('close');  
});

  jQuery(".sticky_icon, .close_sticky_form, .close_form, .open_stky_form").on("click", function() {
    jQuery(".stickr_form").toggleClass("active");
  });


$(window).scroll(function() {
    
    const footerToTop = $('.ft_copyright').position().top;
    const scrollTop = $(document).scrollTop() + $(window).height();

    const difference = scrollTop - footerToTop;
    const bottomValue = scrollTop > (footerToTop + 60) ? difference : 60;

    //console.log(difference)

    $('.sticky_form_wrap').css('bottom', bottomValue + "px");
    
});


  

});

/*end slick slider*/


// Form Validation
const validateInput = input => {
  console.log('Validating input with placeholder:', input.getAttribute('placeholder'));

  // Remove * from the placeholder and replace spaces with hyphens
  const placeholder = input.getAttribute('placeholder').replace(/\*/g, '').replace(' ', '-').toLowerCase();
  
  // Validation logic for each input
  switch (placeholder) {
    case 'full-name':
      console.log('Checking full name...');
      // Validate full name
      if (input.value === '') {
        showError(input, 'Please input your name');
        input.classList.add('false');
        return false;
      } else {
        clearError(input);
        input.setAttribute('validated', 'true');
        return true;
      }

    case 'zip-code':
      console.log('Checking zip code...');
      // Validate zip code
      const zipCodeRegex = /^\d{5}(?:-\d{4})?$/;
      if (input.value === '') {
        showError(input, 'Please input a zip code');
        input.setAttribute('validated', 'false');
        return false;
      } else if (!zipCodeRegex.test(input.value)) {
        showError(input, 'Please input a correct zip code (e.g., 12345)');
        input.setAttribute('validated', 'false');
        return false;
      } else {
        clearError(input);
        input.setAttribute('validated', 'true');
        return true;
      }

    case 'callback-number':
    case 'phone-number':
    case 'phone':
      console.log('Checking phone number...');
      // Validate phone number
      const phoneNumberRegex = /^[1-9]\d{2}-?\d{3}-?\d{4}$/;
      if (input.value === '') {
        showError(input, 'Please input a phone number');
        input.setAttribute('validated', 'false');
        return false;
      } else if (!phoneNumberRegex.test(input.value)) {
        showError(input, 'Please input a valid phone number');
        input.setAttribute('validated', 'false');
        return false;
      } else {
        clearError(input);
        input.setAttribute('validated', 'true');
        return true;
      }

    case 'email':
    case 'email-address':
      console.log('Checking email...');
      // Validate email
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (input.value === '') {
        showError(input, 'Please input an email address');
        input.setAttribute('validated', 'false');
        return false;
      } else if (!emailRegex.test(input.value)) {
        showError(input, 'Please input a valid email address (e.g., xxx@xxx.xx)');
        input.setAttribute('validated', 'false');
        return false;
      } else {
        clearError(input);
        input.setAttribute('validated', 'true');
        return true;
      }

    default:
      console.log('No validation needed for:', placeholder);
      return true;
  }
};

// Show error message
const showError = (input, message) => {
  console.log('Showing error for:', input.getAttribute('placeholder'), 'Message:', message);
  
  if (input.parentNode.querySelectorAll('.error-message').length <= 0) {
    const errorContainer = document.createElement('div');
    errorContainer.classList.add('error-message');
    input.after(errorContainer);
  }

  input.parentNode.querySelectorAll('.error-message').forEach(error => {
    error.classList.remove('hidden');
    error.innerHTML = message;
  });
};

// Clear the error message if input is valid
const clearError = (input) => {
  console.log('Clearing error for:', input.getAttribute('placeholder'));

  input.parentNode.querySelectorAll('.error-message').forEach(error => {
    error.classList.add('hidden');
    error.innerHTML = ''; // Clear the error message
  });
};

function formBuilderCallback(formId) {
  console.log('Initializing form validation for form:', formId);

  document.querySelectorAll('.wscustomcontactform').forEach(form => {
    form.querySelectorAll('.submit-btn').forEach(submitBtn => {
      submitBtn.addEventListener('click', e => {
        let formValid = true; // Track overall form validation state
        form.querySelectorAll('input:not([type=hidden])').forEach((input) => {
          input.removeAttribute('validated');
          input.parentNode.querySelectorAll('.error-message').forEach(error => {
            error.classList.add('hidden');
          });

          if (!validateInput(input)) {
            console.log('Input is invalid:', input.getAttribute('placeholder'));
            e.preventDefault();
            formValid = false;
          }
        });

        if (formValid) {
          console.log('Form submitted successfully');
        } else {
          console.log('Form submission prevented due to validation errors');
        }
      });
    });
  });
}


